import { fetcher } from "helpers/fetcher";

import { TDeleteJobListingImageReq, TDeleteJobListingImageRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteJobListingImage = async (
  payload: TDeleteJobListingImageReq
) => {
  return await fetcher<
    TDeleteJobListingImageRes,
    TDeleteJobListingImageReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_JOB_LISTING_IMAGE, {
    data: payload.data,
    headers: {
      [API_HEADER.CORP_ID]: payload.idCorp,
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_JOB_LISTING_IMAGE.version,
    },
  });
};

export const mutationDeleteJobListingImage = async (
  payload: TDeleteJobListingImageReq
) => {
  return (await deleteJobListingImage(payload)).data.message;
};

mutationDeleteJobListingImage._key = (payload: TDeleteJobListingImageReq) => [
  ENDPOINT.CORPORATION.DELETE_JOB_LISTING_IMAGE.url,
  payload,
];
